//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const moment = require("moment-timezone");
import api from "@/services/api";
import {
  server,
  imagemasterTMUrl,
  filemasterTMUrl,
} from "@/services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import pdfvuer from "pdfvuer";
import html2pdf from "html2pdf.js";

export default {
  name: "MasterTrademark",
  async mounted() {
    this.$showLoader();
    await api.checkVersion();
    // ----------------- Check Authorize ---------------------------
    this.userId = localStorage.getItem(server.USER_ID);
    let yourUrlString = window.location;
    // alert(yourUrlString);

    let parser = document.createElement("a");
    parser.href = yourUrlString;

    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);
    // alert("authorize_id:" + this.authorize_id);
    if (this.authorize_id == null || this.authorize_id == 0) {
      // this.$router.push("/login");
      this.$store.state.global_dialog = true;
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center"
      );
      this.$router.back();
    }

    const router_path = parser.pathname.replace("/", "");

    const res_auth = await api.getAuthorize(this.userId, router_path);

    // console.log("res_auth:" + JSON.stringify(res_auth.data));

    this.authorize_view = res_auth.data[0].smd_view >= 1 ? true : false;
    this.authorize_add = res_auth.data[0].smd_add >= 1 ? true : false;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1 ? true : false;
    this.authorize_del = res_auth.data[0].smd_del >= 1 ? true : false;

    // console.log("res_auth:" + JSON.stringify(res_auth.data));
    // console.log("authorize_view:" + this.authorize_view);
    // console.log("authorize_add:" + this.authorize_add);
    // console.log("authorize_edit:" + this.authorize_edit);
    // console.log("authorize_del:" + this.authorize_del);
    // this.$router.back();

    // ----------------- Check Authorize ---------------------------
    if (this.userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }
    if (!this.authorize_view) {
      this.$router.push("/not-found");
    }

    // ----------------- Check Authorize ---------------------------

    // await this.loaddatamastertmLimit200();
    this.$hideLoader();
    await this.loaddatatmupdatestatus();
    // await this.loaddatamastertmAll();
  },
  watch: {
    show: function (s) {
      if (s) {
        this.getPdf();
      }
    },
    // page: function(p) {
    //   if (
    //     window.pageYOffset <= this.findPos(document.getElementById(p)) ||
    //     (document.getElementById(p + 1) &&
    //       window.pageYOffset >= this.findPos(document.getElementById(p + 1)))
    //   ) {
    //     // window.scrollTo(0,this.findPos(document.getElementById(p)));
    //     document.getElementById(p).scrollIntoView();
    //   }
    // },
  },
  components: {
    SuccessDialog,
    SuccessDialogPush,
    pdf: pdfvuer,
  },
  data(vm) {
    const today = new Date();
    const todayStr = `${String(today.getDate()).padStart(2, "0")}/${String(
      today.getMonth() + 1
    ).padStart(2, "0")}/${today.getFullYear()}`;

    const plus30 = new Date();
    plus30.setDate(today.getDate() + 30);
    const plus30Str = `${String(plus30.getDate()).padStart(2, "0")}/${String(
      plus30.getMonth() + 1
    ).padStart(2, "0")}/${plus30.getFullYear()}`;

    // แปลง DD/MM/YYYY เป็น YYYY-MM-DD สำหรับ DatePicker
    const toYMD = (ddmmyyyy) => {
      const [dd, mm, yyyy] = ddmmyyyy.split("/");
      return `${yyyy}-${mm}-${dd}`;
    };
    return {
      carouselIndex: 0,
      images: [],
      previews: [],
      imagenames: [],
      dialogprevie: false,
      preview_mastertm_id: 0,
      preview_mastertm_file_no: "",
      menuadddatefrom: false,

      searchdatefrom: todayStr,
      searchdatefromPicker: toYMD(todayStr),
      menuadddateto: false,
      searchdateto: plus30Str,
      searchdatetoPicker: toYMD(plus30Str),
      tableLoading: false,

      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      options: {
        page: 1,
        itemsPerPage: 200,
        sortBy: [],
        sortDesc: [],
      },
      // Pagination
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      totalItems: 0,
      dataAll2: [],
      mDataArray2: [],

      userId: 0,
      authorize: [],
      authorize_view: false,
      authorize_add: false,
      authorize_edit: false,
      authorize_del: false,
      authorize_id: 0,
      search_tmp: "",
      showfilenameappointment: "",
      dialogAppointment: false,
      itemsPerPageArray: [10, 15, 20],
      pageSize: 3,
      pageSizes: [3, 6, 9],
      // pageCount: 0,
      // itemsPerPage: 100,
      load_bg: false,
      // page: 1,
      numPages: 0,
      pdfdata: undefined,
      errors: [],
      scale: "page-width",
      dialogEditmastertm: false,
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      dialogAddmastertm: false,
      dialogDelete: false,
      deletedItem: 0,
      deletedIndex: 0,
      isShowPassword: false,
      fullPage: true,
      datefrom: vm.formatDate(new Date().toISOString().substr(0, 10)),
      dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      search: "",
      mDataArray: [],
      mDataArrayappointment: [],
      headers: [
        {
          text: "Object Type",
          value: "objecttype_code",
          divider: true,
          width: "250px",
        },
        {
          text: "File No.",
          align: "left",
          // sortable: false,
          value: "file_no",
          width: "120px",
          divider: true,
        },
        {
          text: "Application No.",
          value: "app_no",
          divider: true,
          width: "140px",
        },
        {
          text: "Country",
          value: "country",
          divider: true,
          width: "140px",
        },
        {
          text: "Registration No.",
          value: "regis_no",
          divider: true,
          width: "140px",
        },
        { text: "Class No.", value: "class_no", divider: true, width: "120px" },
        {
          text: "Trademark Name",
          value: "trademark",
          divider: true,
          width: "200px",
        },
        {
          text: "",
          value: "number_file",
          divider: true,
          width: "50px",
          align: "center",
        },
        {
          text: "Status",
          value: "tmupdatestatus_name",
          divider: true,
          width: "120px",
        },

        {
          text: "Client",
          value: "name_of_client",
          divider: true,
          width: "200px",
        },
        {
          text: "Agent Reference",
          value: "cliant_ref",
          divider: true,
          width: "200px",
        },
        // { text: "Mark Status", value: "tmupdatestatus_name", divider: true },
        // { text: "Client Ref", value: "cliant_ref", divider: true },
        // { text: "Owner", value: "owner_contact_name", divider: true },
        {
          text: "Agent",
          value: "agent_contact_name",
          divider: true,
          width: "200px",
        },
        // { text: "Next Renew", value: "date_of_renewal_show", divider: true },
        {
          text: "Associate",
          value: "associate_contact_name",
          divider: true,
          width: "200px",
        },
        {
          text: "New Renewal",
          value: "date_of_renewal_show",
          divider: true,
          align: "center",
          width: "150px",
        },
        {
          text: "",
          value: "actions",
          width: "200px",
          align: "left",
          divider: true,
        },
      ],
      headersappointment: [
        {
          text: "File No.",
          align: "left",
          // sortable: false,
          value: "refno",
          divider: true,
        },
        { text: "Application No.", value: "app_no", divider: true },
        { text: "Trademark Name", value: "trademark_name", divider: true },
        { text: "Agent", value: "agent_contact_name", divider: true },

        {
          text: "Work Type",
          align: "left",
          // sortable: true,
          value: "documenttype_code",
          width: "10%",
          divider: true,
        },
        { text: "Notice Type", value: "notice_name", divider: true },
        { text: "Final Deadline", value: "enddate", divider: true },
        { text: "Filed Date", value: "filed_date", divider: true },
        { text: "Status", value: "statusnow", divider: true },
        {
          text: "",
          value: "actions",
          width: "15%",
          align: "left",
          divider: true,
        },
      ],
      showprint: "display:none;",
      print_data: {},
      previewimageedit: null,
      tmstatus: 0,
      tmstatus_list: [],
      showtimelineData: [],
    };
  },
  methods: {
    editItemtimeline(item) {
      const url = `/appointmenttm-edit/${item.appointment_id}`; // หรือใส่ query ?file_no=xxx
      window.open(url, "_blank"); // เปิดหน้าใหม่
    },
    async openeAppoinmentOperationforClosed(data) {
      this.$showLoader();
      var restatus = await api.UpdateNewTm(data.mastertm_id, {
        tmstatusasoff: 1,
      });

      setTimeout(() => {
        this.onSearchPagination();
        this.$hideLoader();
      }, 500);
    },
    async previewTrademarkImage(data) {
      this.preview_mastertm_id = 0;
      this.preview_mastertm_file_no = "";
      var mastertm_id = data.mastertm_id;
      this.dialogprevie = true;
      this.preview_mastertm_id = mastertm_id;
      this.preview_mastertm_file_no = data.file_no;
      this.images = [];
      this.previews = [];
      this.imagenames = [];
      var data_search_tmimage = {
        tbl_id: Number(mastertm_id),
        tbl_name: "mattertm_image",
      };

      const resultTmimage = await api.getAllFileAtLawFile({
        params: data_search_tmimage,
      });

      if (resultTmimage.data.length > 0) {
        const existingTmimage = [];
        for (const [index, item] of resultTmimage.data.entries()) {
          let data = {
            id: item.id,
            name: item.file_name,
            type: item.file_type,
          };
          existingTmimage.push(data);
        }
        this.loadExistingFiles(existingTmimage, "Tmimage");
      }
    },
    loadExistingFiles(existingFiles, type) {
      if (!existingFiles || existingFiles.length === 0) return;

      const files = existingFiles.map((f) => {
        // สร้าง File object เปล่าสำหรับ preview
        const file = new File([], f.name, {
          type: f.type || "application/octet-stream",
        });
        // เพิ่ม property isNew เข้าไปใน File object
        file.isOld = true;
        file.id = f.id;
        return file;
      });

      switch (type) {
        case "Tmimage":
          this.images = files;
          // ✅ สำหรับ preview เก่า ใช้ path URL จริง ไม่ใช่ File object
          this.previews = files.map(
            (f) => `${imagemasterTMUrl}/${this.preview_mastertm_id}/${f.name}`
          );
          this.imagenames = files.map((f) => f.name);
          break;
      }
      console.log(this.previews)
      console.log(this.imagenames)
    },
    formatDateToDDMMYYYY(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    formatDateToYYYYMMDD(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
    // 3. แก้ไขฟังก์ชัน loaddataPagination
    async loaddatatmupdatestatus() {
      const result = await api.getAlltmupdatestatus();
      this.tmstatus_list = result.data;
    },
    async loaddataPagination() {
      var tmp = [];
      this.tableLoading = true;

      try {
        const result = await api.getAllMasterTMPagination(
          1,
          this.itemsPerPage,
          "contact_id",
          "ASC",
          this.search_tmp.trim()
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.limit;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 4. แก้ไขฟังก์ชัน onOptionsUpdate
    async onOptionsUpdate(options) {
      this.tableLoading = true;
      let tmp = [];
      let sortDesc = "";
      if (options.sortDesc[0] == true) {
        sortDesc = "ASC";
      } else {
        sortDesc = "DESC";
      }

      if (!options.sortBy[0]) {
        sortDesc = "ASC";
      }
      if (
        !this.searchdatefromPicker ||
        this.searchdatefromPicker == "" ||
        this.searchdatefromPicker == "null"
      ) {
        this.searchdatefromPicker = null;
      }
      if (
        !this.searchdatetoPicker ||
        this.searchdatetoPicker == "" ||
        this.searchdatetoPicker == "null"
      ) {
        this.searchdatetoPicker = null;
      }

      try {
        const result = await api.getAllMasterTMPagination(
          options.page,
          this.itemsPerPage,
          options.sortBy[0],
          sortDesc,
          this.search_tmp.trim(),
          this.tmstatus,
          this.searchdatefromPicker,
          this.searchdatetoPicker
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.limit;
        this.pageCount = result.data.pagination.totalPages;
        // console.log(this.mDataArray2);
        // this.mDataArray2 = this.mDataArray2.map((item) => {
        //   const images = item.master_images
        //     ? item.master_images.split(",").map((name) => {
        //         const fileName = name.trim();
        //         return {
        //           name: fileName,
        //           url: `${imagemasterTMUrl}/${item.mastertm_id}/${fileName}`, // ปรับ path ให้ตรงกับที่คุณเก็บไฟล์
        //         };
        //       })
        //     : [];

        //   return {
        //     ...item,
        //     master_image_list: images,
        //   };
        // });
      } catch (error) {
        console.error("Error updating options:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 5. แก้ไขฟังก์ชัน loadDataByPage
    async loadDataByPage(pageNumber) {
      this.tableLoading = true;
      let tmp = [];
      if (
        !this.searchdatefromPicker ||
        this.searchdatefromPicker == "" ||
        this.searchdatefromPicker == "null"
      ) {
        this.searchdatefromPicker = null;
      }
      if (
        !this.searchdatetoPicker ||
        this.searchdatetoPicker == "" ||
        this.searchdatetoPicker == "null"
      ) {
        this.searchdatetoPicker = null;
      }

      try {
        const result = await api.getAllMasterTMPagination(
          pageNumber,
          this.itemsPerPage,
          "contact_id",
          "ASC",
          this.search_tmp.trim(),
          this.tmstatus,
          this.searchdatefromPicker,
          this.searchdatetoPicker
        );

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.limit;
        this.pageCount = result.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading page data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    // 6. แก้ไขฟังก์ชัน onSearchPagination
    async onSearchPagination() {
      this.mDataArray2 = [];
      let tmp = [];
      this.page = 1;
      this.tableLoading = true;

      if (
        !this.searchdatefromPicker ||
        this.searchdatefromPicker == "" ||
        this.searchdatefromPicker == "null"
      ) {
        this.searchdatefromPicker = null;
      }
      if (
        !this.searchdatetoPicker ||
        this.searchdatetoPicker == "" ||
        this.searchdatetoPicker == "null"
      ) {
        this.searchdatetoPicker = null;
      }

      var s_data = {
        page: 1,
        limit: this.itemsPerPage,
        sortBy: "contact_id",
        sortDesc: "ASC",
        search: this.search_tmp.trim(),
        tmstatusasoff: this.tmstatus,
      };

      try {
        const result = await api.getAllMasterTMPagination(
          s_data.page,
          s_data.limit,
          s_data.sortBy,
          s_data.sortDesc,
          s_data.search,
          s_data.tmstatusasoff,
          this.searchdatefromPicker,
          this.searchdatetoPicker
        );
        // console.log(JSON.stringify(result.data));

        tmp = result.data.data;
        this.dataAll2 = tmp;
        this.mDataArray2 = tmp;

        this.totalItems = result.data.pagination.totalRecords;
        this.page = result.data.pagination.currentPage;
        this.itemsPerPage = result.data.pagination.limit;
        this.pageCount = result.data.pagination.totalPages;

        this.mDataArray2 = this.mDataArray2.map((item) => {
          const images = item.master_images
            ? item.master_images.split(",").map((name) => {
              const fileName = name.trim();
              return {
                name: fileName,
                url: `${imagemasterTMUrl}/${item.mastertm_id}/${fileName}`, // ปรับ path ให้ตรงกับที่คุณเก็บไฟล์
              };
            })
            : [];

          return {
            ...item,
            master_image_list: images,
          };
        });
      } catch (error) {
        console.error("Error searching data:", error);
      } finally {
        this.tableLoading = false;
      }
    },

    async openPrintAppNo(item) {
      this.$showLoader();
      this.print_data = {};
      this.previewimageedit = null;
      await this.genimage(item);
      this.print_data = item;

      var dataAdd = {
        user_id: localStorage.getItem(server.USER_ID),
        log_in_out_id: localStorage.getItem(server.LOGIN_ID),
        action: "Export",
        table_name: "mastertm",
        table_id: item.mastertm_id,
        date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      };

      await api.addTransectionLog(dataAdd);

      var dataEditLog = {
        last_update: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
      };
      await api.updateLogInOutLog(
        localStorage.getItem(server.LOGIN_ID),
        dataEditLog
      );

      setTimeout(async () => {
        await this.exportToPDF();
        this.$hideLoader();
      }, "2000");
    },
    async genimage(item) {
      this.previewimageedit = `${imagemasterTMUrl}/${item.mastertm_id}/${item.master_images}`;
    },

    openInNewTab(url) {
      window.open(url, "_blank");
    },
    async exportToPDF(advance_id) {
      // this.$refs.html2Pdf.generatePdf();

      this.showprint = "";
      let element = document.getElementById("mydivhtmltobase");
      const opt = {
        margin: [0, 0, 0, 0],
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        // enableLinks: false,
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          useCORS: true,
          // ignoreElements: (e) => {
          //   return e.classList.contains("cke_pagebreak") ||
          //     e.classList.contains("html2pdf__page-break")
          //     ? true
          //     : false;
          // },
        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },
        // pagebreak: { mode: ["avoid-all"], after: ".cke_pagebreak" },
      };

      let abcd = await html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        // .output("bloburl")
        .then(function (pdf) {
          console.log(pdf);
          const totalPages = pdf.internal.getNumberOfPages();
          pdf.deletePage(totalPages);
          return pdf.output("bloburl");
        });
      // console.log(abcd);
      window.open(abcd);
      let blob = await fetch(abcd).then((r) => r.blob());
      this.showprint = "display:none;";

      return;
    },
    async openeditTableAppointment(appointment_id) {
      window.open(`/appointmenttm-edit/${appointment_id}`);
    },
    // 7. แก้ไขฟังก์ชัน onSearch (สำหรับ search box)
    async onSearch() {
      this.tableLoading = true;

      try {
        const result = await api.getMasterTMSearch({
          params: { search_tmp: this.search_tmp.trim() },
        });
        this.mDataArray = result.data;
      } catch (error) {
        console.error("Error searching:", error);
      } finally {
        this.tableLoading = false;
      }
    },
    async loaddatamastertmLimit200() {
      // this.$showLoader();

      const result = await api.getAllMasterTMLimit200();
      console.log(result.data);
      // const result = await api.getAllMasterTM();
      this.mDataArray = result.data;
      // this.$hideLoader();
    },
    async loaddatamastertmAll() {
      // this.$showLoader();
      this.load_bg = true;
      const result = await api.getAllMasterTM();
      console.log(result.data);
      // const result = await api.getAllMasterTM();
      this.mDataArray = this.mDataArray.concat(result.data);

      // this.$hideLoader();
      // alert("load data success");
      // alert(this.mDataArray.length);
      this.load_bg = false;
    },
    async openAppointmentedit(file_no) {
      this.showtimelineData = [];
      this.$showLoader();

      var resTimeline = await api.gettimelinemastertm({
        file_no: file_no.trim(),
      });
      var datalist = [];
      if (resTimeline.data && resTimeline.data.length > 0) {
        for (const [index, item] of resTimeline.data.entries()) {
          console.log(item)
          if (Number(item.doctype) == 7) {
            item.show_date = `Application Date - ${item.receive_date}`;
            item.sort_date = item.receive_date;
          } else if (
            [
              1, 2, 4, 5, 6, 8, 9, 10, 19, 104, 105, 108, 109, 110, 111, 112,
              113, 701, 702, 801, 802, 1002, 1003, 1004, 1005, 1006, 1007, 1009,
              1010, 1011,
            ].includes(Number(item.doctype))
          ) {
            item.show_date = `Submitted Date - ${item.filling_date}`;
            item.sort_date = item.filling_date;
          } else if (Number(item.doctype) == 3) {
            item.show_date = `Renewal Filed Date - ${item.receive_date}`;
            item.sort_date = item.receive_date;
          }

          datalist.push(item);
        }

        const sortedData = datalist.sort((a, b) => {
          // ถ้า a ไม่มี sort_date → ไปหลังสุด
          if (!a.sort_date && b.sort_date) return 1;
          // ถ้า b ไม่มี sort_date → ไปหลังสุด
          if (a.sort_date && !b.sort_date) return -1;
          // ถ้าทั้งคู่ไม่มี sort_date → เท่ากัน
          if (!a.sort_date && !b.sort_date) return 0;

          // แยกวันที่
          const partsA = a.sort_date.split("/");
          const partsB = b.sort_date.split("/");

          // ถ้า format ไม่ครบ → ไปหลังสุด
          if (partsA.length !== 3 || partsB.length !== 3) return 0;

          const [dayA, monthA, yearA] = partsA.map(Number);
          const [dayB, monthB, yearB] = partsB.map(Number);

          const dateA = new Date(yearA, monthA - 1, dayA);
          const dateB = new Date(yearB, monthB - 1, dayB);

          return dateB - dateA; // เรียงจากใหม่ → เก่า
        });

        this.showtimelineData = sortedData;
      }

      this.$hideLoader();
      this.dialogAppointment = true;

      // localStorage.setItem(server.MODELMENU, 6);
      // this.$router.push(`/appointment-trademark-list`);
    },
    async closedialogAppointment() {
      this.dialogAppointment = false;
    },
    async openAppointmentadd(file_no) {
      localStorage.setItem(server.MODELMENU, 6);
      // this.$router.push(`/appointmenttm-add/${file_no}`);
      window.open(`/appointmenttm-add/${file_no}/null`);
    },
    async openeditItem(mastertm_id) {
      // this.$router.push(`/master-trademark-edit/${mastertm_id}`);
      window.open(`/master-trademark-edit/${mastertm_id}`);
    },

    deleteItem(item) {
      this.deletedIndex = this.mDataArray.indexOf(item);
      console.log(item.mastertm_id);
      this.deletedItem = item.mastertm_id;
      this.dialogDelete = true;
    },
    closeDelete() {
      this.deletedItem = 0;
      this.dialogDelete = false;
    },
    async deleteItemConfirm() {
      this.$showLoader();
      this.mDataArray.splice(this.deletedIndex, 1);
      this.dialogDelete = false;
      let setflag = 1;
      // 1 = delete
      const resdel = await api.updateMasterTMDel(this.deletedItem, {
        updatestatus: setflag,
      });
      // const resdel = await api.deleteMasterTM(this.deletedItem);
      console.log(resdel);
      if (resdel.status == 200 || resdel.status == 201) {
        var dataAdd = {
          user_id: localStorage.getItem(server.USER_ID),
          log_in_out_id: localStorage.getItem(server.LOGIN_ID),
          action: "Delete",
          table_name: "mastertm",
          table_id: Number(this.deletedIndex) + 1,
          date: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        };

        await api.addTransectionLog(dataAdd);

        var dataEditLog = {
          last_update: moment()
            .tz("Asia/Bangkok")
            .format("YYYY-MM-DD HH:mm:ss"),
        };
        await api.updateLogInOutLog(
          localStorage.getItem(server.LOGIN_ID),
          dataEditLog
        );

        // this.loaddatadetails();
        this.closeDelete();
        this.$hideLoader();
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "delete data",
          "delete data success",
          "text-h5 green--text text-center",
          "/reloadpage"
        );
        return;
      } else {
        // this.loaddatadetails();
        this.closeDelete();
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "delete data",
          "can't delete data",
          "text-h5 red--text text-center"
        );
        return;
      }
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month - 1}-${day}`;
    },

    async setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
  beforeCreate() {
    console.log("beforeCreate");
    this.$store.state.navMenu = true;
  },
};
